import React, { useMemo, useState } from 'react';
import style from './index.module.css';
import mail from '../../../Assets/mail.svg';
import PasswordIcon from '../../../Assets/PasswordIcon.svg';
import edit from '../../../Assets/edit.svg';
import * as api from '../../../services/api';

import eye from '../../../Assets/eye.svg';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../redux/actions';
import { Link, useNavigate } from 'react-router-dom';

import swAlert from 'sweetalert2';
import RecFirstForm from './RecFirst';
import RecSecondForm from './RecSecond';
import { Spinner } from '@chakra-ui/react';

const RecruiterSignup = () => {
  const exist = useSelector((state) => state.application.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    jobTitle: '',
    password: '',
    email: '',
    profilePhoto: '',
  });
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const FormTitle = ['1', '2'];
  //   console.log(FormTitle.length - 2);

  const validateEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (page === FormTitle.length - 1) {
      if (formData.email && formData.password && formData.email) {
        if (!validateEmail(formData.email)) {
          swAlert.fire({
            icon: 'warning',
            title: 'Please Enter Valid Email',
            timer: 1500,
          });
          setPage(0);
          return;
        }
        const uploadData = new FormData();
        uploadData.append('file', formData.profilePhoto);
        uploadData.append('name', `${formData.firstName} ${formData.lastName}`);
        uploadData.append('email', formData.email);
        uploadData.append('jobTitle', formData.jobTitle);
        uploadData.append('password', formData.password);
        uploadData.append('profile', 'recruiter');

        if (
          formData.email == '' ||
          formData.password == '' ||
          formData.firstName == ''
        ) {
          return swAlert.fire({
            icon: 'warning',
            text: 'Please Check Credentials...',
            timer: 1300,
          });
        }
        try {
          const response = await api.signupRecruiter(uploadData);
          if (response.status === 201) {
            navigate('/hiring/recruiter/selectCompany');
            //   console.log('recr',response.data);
            dispatch(
              authActions.login({
                email: response.data.user?.email,
                password: formData.password,
                profile: 'recruiter',
              })
            );

            //   swAlert.fire("Signed-up successfully");
          }
        } catch (e) {
          // console.log(e.response.data.message);
          if (e.response.data.message == 'User already exists') {
            swAlert.fire({
              icon: 'warning',
              text: 'User already exists',
              timer: 1300,
            });
            navigate('/hiring/recruiter/signup');
            setPage(0);
          } else {
            swAlert.fire({
              icon: 'error',
              text: 'OOPS! Something went wrong...',
              timer: 1300,
            });
          }
        }
      }
    } else {
      setPage(page + 1);
    }
  };

  const changeImage = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    const fileSize = selectedFile.size;
    const fileSizeMb = fileSize / 1024 ** 2;

    if (fileSizeMb < 5) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      // console.log(selectedFile);
      if (!allowedExtensions.exec(selectedFile?.name)) {
        // swAlert.fire("Please upload jpg/jpeg/png file...");
        swAlert.fire({
          icon: 'warning',
          text: 'Please upload jpg/jpeg/png file...',
          timer: 1300,
        });

        return;
      }
      setFormData((state) => ({
        ...state,
        profilePhoto: e.target.files[0],
      }));
      // alert("file is acceptable");
      // Swal.fire("Logo uploaded successfully...");
    } else {
      swAlert.fire({
        icon: 'warning',
        text: 'File size should be less than 5MB',
        timer: 1300,
      });
    }
    // alert("Will be implemented soon!");
  };

  return (
    <div className={style.container}>
      <div className={style.namaskaram}>Create your account!</div>
      <div className={style.welcome}>
        {page == 0 ? 'Lets Create Your Account' : 'Upload your profile picture'}
      </div>
      <form className={style.formContainer}>
        <div>
          {page === 0 && (
            <RecFirstForm handleChange={handleChange} formData={formData} />
          )}
        </div>
        <div>
          {page === 1 && (
            <RecSecondForm changeImage={changeImage} formData={formData} />
          )}
        </div>

        <div className={style.btnGroup}>
          <button
            // disabled={page == 0}
            className={style.backBtn}
            onClick={(e) => {
              e.preventDefault();
              if (page == 0) {
                navigate('/hiring/signup');
              } else {
                setPage((currPage) => currPage - 1);
              }
            }}
          >
            Back
          </button>

          {!formData.email || !formData.firstName || !formData.password ? (
            <button
              disabled
              style={{ cursor: 'not-allowed' }}
              onClick={handleUpload}
              type='button'
              className={style.nextBtn}
            >
              Next
            </button>
          ) : (
            <button
              className={style.nextBtn}
              onClick={handleUpload}
              type='submit'
            >
              Next
            </button>
          )}
        </div>
      </form>
      <div className={style.already}>
        <div>
          Already a member?{' '}
          <Link
            to='/'
            style={{ textDecoration: 'underline', fontWeight: '600' }}
          >
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RecruiterSignup;
